import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFixedAssetLedgerApi } from "../../../apiservice/reports";

export const fetchFixedAssetLedger = createAsyncThunk(
  "fixedAssetLedger/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getFixedAssetLedgerApi({
        accId: filters.accId,
        dateFrom: filters.fromDate,
        dateTo: filters.toDate,
      });

      return {
        ledger: res.data.ledger || [],
        opening_balance: res.data.opening_balance || 0,
        closing_balance: res.data.closing_balance || 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
